import { keepPreviousData } from "@tanstack/react-query";
import { trpc } from "../trpc";
import type { Team } from "@zapier/bff";

interface Input {
  search?: string;
  teamsSearchEnabled?: boolean;
  /** Search teams on this account (e.g. parent org when sharing from a workspace). */
  accountId?: string;
}

export function useQuerySearchTeams({
  search,
  teamsSearchEnabled,
  accountId,
}: Input = {}) {
  const teams = trpc.member.searchTeams.useQuery(
    { search: search || "", accountId },
    {
      placeholderData: keepPreviousData,
      enabled: teamsSearchEnabled,
      trpc: { context: { skipBatching: true } },
    },
  );

  return {
    teams: teams.data || ([] as Team[]),
    isLoading: teams.isLoading,
  };
}
